import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState, useEffect } from 'react';
import Page from '../../../../page';
import Icon from '../../../../core/Icon';
import { Grid, Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import pathUtil from '../../../../utils/pathUtil';
import { DocumentProvider, useDocumentDispatch, useDocumentState, reset, save } from './context/documentContext';
import CsvTable from './CsvTable';
import SidebarData from './Sidebar/Data';
import SidebarRelationships from './Sidebar/Relationships';
import SidebarProperties from './Sidebar/Properties';
import BlockPrompt from '../../../../form/BlockPrompt';
var useStyles = makeStyles(function (theme) {
  return {
    dataGridContainer: {
      height: '100%',
      padding: theme.spacing(2, 3)
    }
  };
}, {
  name: 'ECDataModelEditorWrapper'
});
/** @type React.SFC<import('./types').DataModelEditorProps> */

var DataModelEditor = function DataModelEditor(props) {
  var _useState = useState('data'),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCsvId = _useState4[0],
      setSelectedCsvId = _useState4[1];

  var classes = useStyles(props);
  var documentState = useDocumentState();
  var documentDispatch = useDocumentDispatch();
  useEffect(function () {
    reset(documentDispatch, props.workspace, props.path);
  }, [props.workspace, props.path]);
  var dataSources = documentState && documentState.content ? documentState.content.job.dataSources : [];
  var selectedCsv = dataSources.find(function (csv) {
    return csv.id === selectedCsvId;
  });
  useEffect(function () {
    if (dataSources.length === 0) {
      setSelectedCsvId(null);
    } else if (selectedCsvId === null || !selectedCsv) {
      if (selectedCsvId === null && props.selectedItemId && dataSources.find(function (csv) {
        return csv.id === props.selectedItemId;
      })) setSelectedCsvId(props.selectedItemId);else setSelectedCsvId(dataSources[0].id);
    }
  }, [dataSources]);
  if (documentState === null) return null;
  var dirty = documentState.serverContent !== documentState.content || Object.keys(documentState.csvData).some(function (key) {
    return documentState.csvData[key].edits !== null;
  });
  return React.createElement("div", null, React.createElement(Page.ToolBar, {
    icon: {
      type: 'close',
      onClick: function onClick() {
        return props.onClose();
      }
    },
    leftChildren: pathUtil.getFileCaption(props.path),
    centerChildren: React.createElement(Grid, {
      container: true,
      spacing: 1
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: documentState.isSaving ? 'loading' : 'save',
      onClick: function onClick() {
        documentDispatch({
          type: 'document_saving'
        });
        save(documentDispatch, props.workspace, props.path, documentState);
      },
      disabled: !dirty || documentState.isSaving
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: "undo",
      onClick: function onClick() {
        return documentDispatch({
          type: 'undo'
        });
      },
      disabled: documentState.undoStates.length === 0
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: "redo",
      onClick: function onClick() {
        return documentDispatch({
          type: 'redo'
        });
      },
      disabled: documentState.redoStates.length === 0
    }))),
    color: "navbar"
  }), documentState.isLoading ? React.createElement(Box, {
    top: "calc(50% - 25px)",
    left: "calc(50% - 25px)",
    position: "absolute"
  }, React.createElement(CircularProgress, null)) : React.createElement(Page.Common, {
    sidebar: !documentState.error && {
      variant: 'properties',
      options: [{
        label: 'Data',
        icon: 'data',
        value: 'data'
      }, {
        label: 'Properties',
        icon: 'style',
        value: 'properties'
      }, {
        label: 'Relations',
        icon: 'dependencies',
        value: 'relations'
      }],
      value: activeTab,
      onChange: function onChange(options) {
        return setActiveTab(options.value);
      },
      children: React.createElement("div", {
        className: classes.dataGridContainer
      }, activeTab === 'data' && React.createElement(SidebarData, {
        dataSources: dataSources,
        selectedItemId: selectedCsvId,
        onSelectItemId: setSelectedCsvId,
        workspace: props.workspace,
        path: props.path,
        onEdit: function onEdit() {
          return setActiveTab('properties');
        }
      }), activeTab === 'properties' && React.createElement(SidebarProperties, {
        workspace: props.workspace,
        path: props.path,
        selectedItem: selectedCsv
      }), activeTab === 'relations' && React.createElement(SidebarRelationships, null))
    }
  }, React.createElement("div", null, React.createElement(BlockPrompt, {
    when: dirty
  }), documentState.error ? React.createElement(Typography, {
    color: "error",
    align: "center"
  }, documentState.error) : selectedCsv !== undefined && React.createElement(CsvTable, {
    workspace: props.workspace,
    path: pathUtil.absolute(selectedCsv.src, pathUtil.getFolderPath(props.path))
  }))));
};
/**
 * @param {import('./types').DataModelEditorProps} props
 */


var DataModelEditorWrapper = function DataModelEditorWrapper(props) {
  return React.createElement(DocumentProvider, null, React.createElement(DataModelEditor, props));
};

export default DataModelEditorWrapper;